import React from 'react'
import { Image, Col, Button} from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { addToCart } from '../../slice/itemSlice'

const Item = ({ name, price, tag, image, subCategory, id }) => {
  
  const dispatch = useDispatch();


  return (
    <Col className='gy-2 gy-md-5 gx-3 d-flex flex-column position-relative'lg={3} md={6} sm={12} >
      <Image src={image} fluid style={{maxHeight:"200px",boxShadow:"0 0 12px 1px gray"}} />
      <h3 className='display-6 text-info'>{name.split(" ").slice(0,1)}</h3>
      <h4 className='' >{subCategory}</h4>
      {tag && <p style={{transform:"rotate(90deg)"}} className={`position-absolute px-2 py-1 ${tag === "New" ? "bg-info": "bg-danger text-light"} my-3 mx-2 fs-4`}>{tag}</p>}
      <p className='fs-5 text-black-50'><span className='fw-bold'>$</span> {price}</p>
      <Button onClick={() => dispatch(addToCart(id))} variant="outline-dark">Add to Cart</Button>
    </Col>
  )
}

export default Item